import { useAuth, overrideConfig } from '@/api/billing-primary'

const fetchCloudFront = function ({ projectIdx, month }, serviceIdx) {
    const { auth } = useAuth({ ...overrideConfig, serviceIdx })
    return auth.axiosIns.post('/v1/context', { target: 'CloudFront', params: { projectIdx: [projectIdx], month } })
}

export { fetchCloudFront }

export default {
    fetchCloudFront
}
